import { DataBean } from "../DataBean";

export class AddKpiEmployee extends DataBean {



    public async addKpiEmployeeMeasurement(idKpiMeasurement: any, idAccount: any, idLnFunctionalID: any, value: any, idProject: any, idBusinessCore: any, idEmployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.bi.KpiEmployeeMeasurement_addKpiEmployeeMeasurement_Number_Number_Number_Number_Number_Number_Number", [idKpiMeasurement, idAccount, idLnFunctionalID, value, idProject, idBusinessCore, idEmployee]);
    }

}
